import { atom } from 'jotai';
import { getBootstrapInfoFromLocal } from 'utils/js/bootstrapper';

const cached = getBootstrapInfoFromLocal();

export const bootstrapInfos = atom(cached ?? {});
